import { styled } from '@material-ui/core'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

export const Container = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
})

export const RouteTitle = styled(Link)(({ theme }) => ({
  color: theme.palette.common.black,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    cursor: 'pointer',
  },
  fontSize: 14,
  fontWeight: 'normal',
  lineHeight: '16px',
  '&:last-child': {
    fontWeight: 'bold',
  },
}))

export const SubrouteIcon = styled(ArrowForwardIosIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(1.8),
}))
